import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Theme, useTheme } from '@mui/material';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { materialDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

const SyntaxHighlightedContent = ({ language, content }: { language: string; content: string }) => {
    const theme: Theme = useTheme();

    const handleCopy = () => {
        navigator.clipboard.writeText(content);
    };

    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
                borderRadius: theme.shape.borderRadius,
            }}
        >
            <SyntaxHighlighter language={language} style={materialDark} customStyle={{ margin: '0', fontSize: '0.8em' }}>
                {content}
            </SyntaxHighlighter>
            <ContentCopyIcon
                fontSize="small"
                aria-label="Copy to clipboard"
                titleAccess="Copy to clipboard"
                onClick={handleCopy}
                sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    cursor: 'pointer',
                    color: '#fff',
                    opacity: 0.7,
                    transition: 'opacity 0.2s',

                    '&:hover': {
                        opacity: 1,
                    },
                }}
            />
        </div>
    );
};

export default SyntaxHighlightedContent;
